<nb-card class="add-sub-dialog">
  <nb-card-header>{{ 'crm.add_submission' | translate }}</nb-card-header>
  <nb-card-body>
    <div *ngIf="errorMessage" class="error-banner">{{ errorMessage }}</div>

    <label class="field">
      <span class="field-label">{{ 'crm.consultant' | translate }} *</span>
      <bst-list-adder
        target="member"
        [single]="true"
        [autolist]="true"
        [filters]="{logo: true}"
        [sortResults]="byRank"
        [listTemplate]="consultantTpl"
        [(ngModel)]="selectedConsultant">
      </bst-list-adder>
    </label>
    <p class="dup-warning" *ngIf="isDuplicate">
      {{ 'crm.dup_consultant' | translate }}
    </p>
  </nb-card-body>
  <nb-card-footer class="dialog-actions">
    <button nbButton ghost type="button" (click)="cancel()">{{ 'cancel' | translate }}</button>
    <button nbButton status="primary" type="button" [disabled]="!canSubmit" (click)="submit()">{{ 'crm.add' | translate }}</button>
  </nb-card-footer>
</nb-card>

<ng-template #consultantTpl let-user="result" let-index="index">
  <span class="consultant-row">
    <nb-user class="consultant-name" color="#eee" [name]="user.name" [picture]="Globals.logo(user)" size="small"></nb-user>
    <span *ngIf="score(user) !== null" class="match-badge">{{ score(user) }}%</span>
    <!-- index === -1 only for the selected chip (list-adder.component.html), never a
         search-result row, so this can't collide with the row's own select-on-click. -->
    <a *ngIf="index === -1" class="profile-link" [routerLink]="['/users', user.id]" target="_blank"
       [attr.aria-label]="'crm.view_profile' | translate">
      <nb-icon icon="external-link-outline"></nb-icon>
    </a>
  </span>
</ng-template>
